import { render, staticRenderFns } from "./OfferPartCommissionSlice.vue?vue&type=template&id=606053d7&scoped=true&"
import script from "./OfferPartCommissionSlice.vue?vue&type=script&lang=js&"
export * from "./OfferPartCommissionSlice.vue?vue&type=script&lang=js&"
import style0 from "./OfferPartCommissionSlice.vue?vue&type=style&index=0&id=606053d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606053d7",
  null
  
)

export default component.exports